import { ClientAdminButtonComponent } from './ClientAdminButtonComponent.jsx';

export const AcceptButton = ({ tileId }) => (
  <ClientAdminButtonComponent
    liClass="accept_button"
    aClass="update_status accept button"
    aData={{
      action: 'accept',
      status: 'plan',
      tileId,
    }}
    buttonText="Accept"
  />
);

export const ArchiveButton = ({ tile, changeTileStatus }) => (
  <ClientAdminButtonComponent
    aClass="button update_status left"
    aData={{
      action: 'archive',
      status: 'archive',
      tileId: tile.id,
    }}
    buttonText="Archive"
    onClickAction={() => changeTileStatus(tile)}
  />
);

export const DirectDestroyButton = ({ tileId, onClickAction }) => (
  <ClientAdminButtonComponent
    liClass="destroy pill right"
    aClass="delete_tile"
    aData={{
      action: 'delete',
      tileId,
    }}
    faIcon="fa-regular fa-trash-can"
    onClickAction={onClickAction}
  />
);

export const EditButton = ({ tileId, activeStatus, onClickAction }) => (
  <ClientAdminButtonComponent
    liClass="edit_button right"
    aClass="edit"
    aData={{
      action: 'edit',
      status: activeStatus,
      tileId,
    }}
    onClickAction={onClickAction}
    faIcon="fa-regular fa-pencil"
    spanText="Edit"
  />
);

export const IgnoreButton = ({ tileId }) => (
  <ClientAdminButtonComponent
    liClass="ignore_button"
    aClass="update_status ignore button outlined"
    aData={{
      action: 'ignore',
      status: 'ignored',
      tileId,
    }}
    buttonText="Ignore"
  />
);

export const IncompleteEditButton = ({
  tileId,
  activeStatus,
  onClickAction,
}) => (
  <ClientAdminButtonComponent
    liClass="incomplete_button"
    aClass="button left"
    aData={{
      action: 'edit',
      status: activeStatus,
      tileId,
    }}
    faIcon="fa-regular fa-pencil"
    spanText="Edit"
    onClickAction={onClickAction}
  />
);

export const IncompleteDestroyButton = ({ tileId, onClickAction }) => (
  <ClientAdminButtonComponent
    liClass="destroy pill right incomplete"
    aClass="delete_tile"
    aData={{
      action: 'delete',
      tileId,
    }}
    faIcon="fa-solid fa-trash-can"
    onClickAction={onClickAction}
  />
);

export const UnarchiveButton = ({ tile, changeTileStatus }) => (
  <ClientAdminButtonComponent
    aClass="button update_status left"
    aData={{
      action: 'unarchive',
      status: 'active',
      tileId: tile.id,
    }}
    buttonText="Post Again"
    onClickAction={() => changeTileStatus(tile)}
  />
);

export const UndoIgnoreButton = ({ tileId }) => (
  <ClientAdminButtonComponent
    liClass="undo_ignore_button"
    aClass="update_status undo_ignore button outlined"
    aData={{
      action: 'unignore',
      status: 'user_submitted',
      tileId,
    }}
    buttonText="Undo Ignore"
  />
);
